export const ROLE_TYPES = {
  BRAND_MANAGER: 1,
  MANAGER: 2,
  SUPERUSER: 3,
  WAREHOUSE_MANGER: 4,
  CONTROLLER: 5,
};
